var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.7125 17.1875H19.6625C17.15 17.1875 15.9375 16.025 15.9375 13.625V5.12501C15.9375 2.72501 17.1625 1.56251 19.6625 1.56251H24.7125C27.225 1.56251 28.4375 2.72501 28.4375 5.12501V13.625C28.4375 16.025 27.2125 17.1875 24.7125 17.1875ZM19.6625 3.43751C18.075 3.43751 17.8125 3.86251 17.8125 5.12501V13.625C17.8125 14.8875 18.075 15.3125 19.6625 15.3125H24.7125C26.3 15.3125 26.5625 14.8875 26.5625 13.625V5.12501C26.5625 3.86251 26.3 3.43751 24.7125 3.43751H19.6625V3.43751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.7125 28.4375H19.6625C17.15 28.4375 15.9375 27.275 15.9375 24.875V22.625C15.9375 20.225 17.1625 19.0625 19.6625 19.0625H24.7125C27.225 19.0625 28.4375 20.225 28.4375 22.625V24.875C28.4375 27.275 27.2125 28.4375 24.7125 28.4375ZM19.6625 20.9375C18.075 20.9375 17.8125 21.3625 17.8125 22.625V24.875C17.8125 26.1375 18.075 26.5625 19.6625 26.5625H24.7125C26.3 26.5625 26.5625 26.1375 26.5625 24.875V22.625C26.5625 21.3625 26.3 20.9375 24.7125 20.9375H19.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3374 28.4375H5.28744C2.77494 28.4375 1.56244 27.275 1.56244 24.875V16.375C1.56244 13.975 2.78744 12.8125 5.28744 12.8125H10.3374C12.8499 12.8125 14.0624 13.975 14.0624 16.375V24.875C14.0624 27.275 12.8374 28.4375 10.3374 28.4375ZM5.28744 14.6875C3.69994 14.6875 3.43744 15.1125 3.43744 16.375V24.875C3.43744 26.1375 3.69994 26.5625 5.28744 26.5625H10.3374C11.9249 26.5625 12.1874 26.1375 12.1874 24.875V16.375C12.1874 15.1125 11.9249 14.6875 10.3374 14.6875H5.28744V14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3374 10.9375H5.28744C2.77494 10.9375 1.56244 9.77501 1.56244 7.37501V5.12501C1.56244 2.72501 2.78744 1.56251 5.28744 1.56251H10.3374C12.8499 1.56251 14.0624 2.72501 14.0624 5.12501V7.37501C14.0624 9.77501 12.8374 10.9375 10.3374 10.9375ZM5.28744 3.43751C3.69994 3.43751 3.43744 3.86251 3.43744 5.12501V7.37501C3.43744 8.63751 3.69994 9.06251 5.28744 9.06251H10.3374C11.9249 9.06251 12.1874 8.63751 12.1874 7.37501V5.12501C12.1874 3.86251 11.9249 3.43751 10.3374 3.43751H5.28744V3.43751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.76332ee85177299ff3e3d677301991da.svg";
export { ForwardRef as ReactComponent };